var map = {
	"./add-friend.svg": "702f",
	"./bar-chart-black.svg": "bfe6",
	"./bar-chart.svg": "bde4",
	"./bed.svg": "f035",
	"./calendar-black.svg": "0503",
	"./calendar.svg": "b8bd",
	"./checklist.svg": "f589",
	"./clipboard-black.svg": "9462",
	"./clipboard.svg": "4247",
	"./clipboards-black.svg": "640e",
	"./clipboards.svg": "d3c1",
	"./clock.svg": "755b",
	"./coffee.svg": "aa5e",
	"./cross.svg": "2ad7",
	"./delete.svg": "0d45",
	"./direct-download-grey.svg": "523c",
	"./direct-download.svg": "4616",
	"./doctor.svg": "0ea6",
	"./documents-black.svg": "cdd7",
	"./documents.svg": "70cd",
	"./drugs-black.svg": "f9c0",
	"./drugs.svg": "22af",
	"./edit.svg": "daf0",
	"./healthcare.svg": "06f01",
	"./home.svg": "ac9d",
	"./house.svg": "750c",
	"./invoice.svg": "c7d2",
	"./labs.svg": "297e",
	"./leader-black.svg": "55e5",
	"./leader.svg": "212e",
	"./loupe-grey.svg": "d884",
	"./loupe.svg": "f39b3",
	"./newspaper.svg": "ae46",
	"./paper-plane-grey.svg": "9945",
	"./paper-plane.svg": "7fba",
	"./people-black.svg": "53c5",
	"./people.svg": "1a5b",
	"./pills-bottle.svg": "725a",
	"./restore.svg": "2a09",
	"./settings-black.svg": "f7f7",
	"./settings.svg": "9174",
	"./shifts-teams.svg": "2231",
	"./speedometer.svg": "71c6",
	"./stethoscope.svg": "1012",
	"./users-black.svg": "638a",
	"./users-blue.svg": "f617",
	"./users-gray.svg": "2d46",
	"./users.svg": "d956",
	"./witness.svg": "4453"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";